import DOMPurify from 'isomorphic-dompurify';

/**
 * Parse and sanitize comment HTML content while preserving mention links
 * This function ensures that user mentions are properly styled
 */
export const parseCommentContent = (htmlContent: string): string => {
	if (!htmlContent) return '';

	// Configure DOMPurify to keep the mention links
	const cleanHtml = DOMPurify.sanitize(htmlContent, {
		ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'a', 'ol', 'ul', 'li', 'span'],
		ALLOWED_ATTR: ['href', 'style', 'class'],
		KEEP_CONTENT: true
	});

	// Create a temporary div to parse the HTML
	const tempDiv = document.createElement('div');
	tempDiv.innerHTML = cleanHtml;

	// Find all links that are mentions (href starts with "mention:")
	const links = tempDiv.querySelectorAll('a[href^="mention:"]');
	
	links.forEach((link) => {
		// Style the mention links
		link.setAttribute('class', 'user-mention');
		link.setAttribute('style', 'color: #5a7ebf; font-weight: 600; text-decoration: none; cursor: default;');
		// Remove the href to prevent navigation
		link.removeAttribute('href');
	});

	return tempDiv.innerHTML;
};

/**
 * Component CSS for user mentions
 * Add this to your global CSS or component styles
 */
export const mentionStyles = `
	.user-mention {
		color: #5a7ebf;
		font-weight: 600;
		text-decoration: none;
		cursor: default;
		padding: 0 2px;
		border-radius: 2px;
		background-color: rgba(79, 129, 238, 0.1);
	}
	
	.user-mention:hover {
		background-color: rgba(79, 129, 238, 0.15);
	}
`;
